import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { setPinThunk } from "../features/auth/authThunk";
import OtpInputComponent from "../components/layout/OtpInputComponent";
import Button from "../components/ui/Button";

const SetPin: React.FC = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { mobileNumber, deviceId, uuid, loading, error, consentHandle, existUser } = useAppSelector(
        (s) => s.auth
    );

    const searchParams = new URLSearchParams(location.search);
    const isResetMode = searchParams.get("mode") === "reset";

    const [pin, setPin] = useState("");

    // Redirect if no mobile number or if user already exists
    useEffect(() => {
        if (!mobileNumber) {
            navigate("/login");
        } else if (existUser && !isResetMode) {
            navigate("/verifyPin");
        }
    }, [mobileNumber, existUser, navigate, isResetMode]);

    // Local explicit form submission handler
    const handleSubmit = async () => {
        if (pin.length === 6) {
            const resultAction = await dispatch(setPinThunk({ mobileNumber, pin, deviceId: uuid || deviceId, consentHandle }));
            if (setPinThunk.fulfilled.match(resultAction)) {
                navigate("/selectAccountType");
            }
        }
    };

    const maskedMobile = mobileNumber ? "XXXXXX" + mobileNumber.slice(-4) : "";

    return (
        <div className="flex flex-col min-h-screen bg-fin-bg">
            <div className="flex-1 flex flex-col p-6 items-center w-full max-w-sm mx-auto mt-10">
                <div className="h-16 w-16 bg-fin-primary/10 rounded-full flex items-center justify-center mb-8 border border-fin-primary/20">
                    <svg className="w-8 h-8 text-fin-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07" />
                    </svg>
                </div>

                <div className="text-center mb-10 w-full">
                    <h2 className="text-xl font-bold text-white">{isResetMode ? "Reset your security PIN" : "Protect your account"}</h2>
                    <p className="text-sm text-fin-slate mt-2 leading-relaxed">
                        {isResetMode
                            ? `Set a new 6-digit MPIN for +91 ${maskedMobile}`
                            : `Set a custom security MPIN for +91 ${maskedMobile} to secure your data.`}
                    </p>
                </div>

                <div className="w-full flex justify-center mb-8">
                    <OtpInputComponent
                        value={pin}
                        onChange={(val) => setPin(val)}
                    />
                </div>

                {error && (
                    <div className="text-center w-full mb-6 p-3 bg-red-900/10 border border-red-900/20 rounded-lg">
                        <p className="text-xs text-red-400 font-medium">{error}</p>
                    </div>
                )}
            </div>

            <div className="w-full bg-fin-surface border-t border-fin-border p-4 pb-10 mt-auto">
                <div className="max-w-sm mx-auto">
                    <Button
                        variant="primary"
                        fullWidth
                        disabled={pin.length < 6 || loading}
                        onClick={handleSubmit}
                        className="py-4 text-[15px] font-bold"
                    >
                        {loading ? "Saving PIN..." : (isResetMode ? "Reset MPIN & Proceed" : "Set MPIN & Proceed")}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default SetPin;
